export const authApiUrl = process.env.REACT_APP_AUTH_API_URL;
export const authApiVersion = process.env.REACT_APP_AUTH_API_VERSION;

export const shopifyClientId = process.env.REACT_APP_SHOPIFY_CLIENT_ID;
export const shopifyRedirectUrl = process.env.REACT_APP_SHOPIFY_REDIRECT_URL;